import gql from 'graphql-tag';

import { getLanguageWithoutFormality, type Language } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';
import type { Override } from 'src/lib/types';
import type {
  BackendCustomerPersona,
  BackendCustomerPersonaConnection,
  BackendMutationExtractCustomerPersonaFromEditorArgs,
} from 'src/types/backend';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractCustomerPersonaFromEditor(
    $customerId: ID!
    $urls: [String!]
    $text: String
    $resourceId: ID
    $count: Int
    $language: String
  ) {
    extractCustomerPersonaFromEditor(
      customerId: $customerId
      urls: $urls
      text: $text
      resourceId: $resourceId
      count: $count
      language: $language
    ) {
      edges {
        node {
          ...CustomerPersona
        }
      }
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

type Variables = Override<
  BackendMutationExtractCustomerPersonaFromEditorArgs,
  {
    language?: Language;
  }
>;
type Result = BackendCustomerPersonaConnection;

export const extractCustomerPersonaFromEditor = async ({ language, ...rest }: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      language: language ? getLanguageWithoutFormality(language) : undefined,
    },
    options: {
      traceAcRequests: true,
    },
  });
  const result = getSingleProp<Result>(response.data);
  return unwrapEdges<BackendCustomerPersona>(
    result?.edges as Array<{ node: BackendCustomerPersona }> | undefined
  );
};
